import { apiSlice } from '../../api/slice'

export const seasonsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentSeason: builder.query({
      query: () => ({
        url: `/season/current`,
      }),
    }),
    getCurrentSeasonProgress: builder.query({
      query: () => ({
        url: `/season/progress/current`,
      }),
    }),
    acknowledgeSeasonStart: builder.mutation({
      query: ({ seasonId }) => ({
        url: `/season/progress/${seasonId}/acknowledge-start`,
        method: 'POST',
      }),
    }),
    acknowledgeSeasonEnd: builder.mutation({
      query: ({ seasonId }) => ({
        url: `/season/progress/${seasonId}/acknowledge-end`,
        method: 'POST',
      }),
    }),
    getPreviousSeasons: builder.query({
      query: () => ({
        url: `/season/previous`, // TODO: add pagination one day
      }),
    }),
    getPreviousSeasonsProgress: builder.query({
      query: () => ({
        url: `/season/progress/previous`,
      }),
    }),
    getSeasonProgressById: builder.query({
      query: ({ seasonId }) => ({
        url: `/season/progress/${seasonId}`,
      }),
    }),
    getSeasonsWithPendingAcknowledgeEnd: builder.query({
      query: () => ({
        url: "/season/pending-acknowledge-end",
      }),
    }),
    getGraduatedMemecoinsBySeasonId: builder.query({
      query: ({ seasonId }) => ({
        url: `/season/${seasonId}/graduated-memecoins`,
      }),
    }),

  }),
})

export const {
  useGetCurrentSeasonQuery,
  useLazyGetCurrentSeasonQuery,
  useGetCurrentSeasonProgressQuery,
  useLazyGetCurrentSeasonProgressQuery,
  useAcknowledgeSeasonStartMutation,
  useAcknowledgeSeasonEndMutation,
  useGetPreviousSeasonsQuery,
  useLazyGetPreviousSeasonsQuery,
  useGetPreviousSeasonsProgressQuery,
  useLazyGetPreviousSeasonsProgressQuery,
  useGetSeasonProgressByIdQuery,
  useGetSeasonsWithPendingAcknowledgeEndQuery,
  useLazyGetSeasonsWithPendingAcknowledgeEndQuery,
  useLazyGetGraduatedMemecoinsBySeasonIdQuery
} = seasonsApiSlice
